package com.schoolconnect.app.feature.links

import androidx.compose.runtime.Composable
import com.schoolconnect.app.feature.placeholder.FeaturePlaceholderScreen

@Composable
fun LinksScreen(
    state: LinksUiState,
    onEvent: (LinksUiEvent) -> Unit,
    onBack: () -> Unit
) {
    FeaturePlaceholderScreen(
        title = "Links",
        description = "Relationship and assignment links.",
        onBack = onBack
    )
}

